/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/prefer-default-export */

import { apiClient, handleResponse } from './axios';

async function getAllCodes() {
  const url = '/code/';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCodesByCompanyId(companyId) {
  const url = `/code/company/${companyId}`;
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

export const codeServices = {
  getAllCodes,
  getCodesByCompanyId,
};
